#import "./SearchIndexFull.graphql"
#import "./TimestampsFull.graphql"
#import "./AddressFull.graphql"
#import "./CompanyFull.graphql"

fragment WeddingFormFull on WeddingForm {
  id
  fullName
  email
  phoneNumber
  weddingDate
  cuttingTime
  weddingLocation
  estimatedGuests
  cakeDeliveredByMyself
  fillingTasteTest
  billingAddress {
    ...AddressFull
  }
  company {
    ...CompanyFull
  }
  note
  status
  orderId
  tenantId
  gdprApprovedAt
  ...TimestampsFull
  ...SearchIndexFull
}
